import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';
import reportWebVitals from "./reportWebVitals";
import { apiSlice } from './Redux/apiSlice';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
const store = configureStore({
  reducer: rootReducer, middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware), devTools: true
});
root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
